module.exports = "mutation ($id: ID!) {\n  DraftDelete(id: $id) {\n    id\n  }\n}\n"